export const AUTHORS_LIST_CONTENT = {
    errorDeactivate: 'Ошибка деактивации автора',
    errorActivate: 'Ошибка активации автора',
    authorsNone: 'Авторы отсутствуют'
}